export { default } from "bullitttime-embermodelsevent/models/result";
